module.exports = __webpack_public_path__ + "static/media/rysbai-avtr.35e04767.jpg";